<template>
  <div class="row rowcorrect rowEqual" v-if="checkRoles('configuration', 'FinancialReportList')">
    <div class="col-lg-12 col-xs-12">
      <b-card>
        <h6 class="card-title mt-0">{{$t('views.reports.notfullbankpayments.showall')}}</h6>
        <b-card-body>
          <Loader v-if="loading"></Loader>
          <b-table
            v-else
            striped hover
            :borderless="true"
            :items="rowsData"
            :fields="columns"
          >
            <template v-slot:cell(paymentDate)="data">
              <router-link :to="{ name: 'EXSBPaymentsMadeUpdate', params: { id: '/core/public/index.php/api/e_x_s_b_payments_mades/' + data.item.paymentsMadeId }}">
                {{ data.item.paymentDate }}
              </router-link>
            </template>
            <template v-slot:cell(idEXSBInvoice)="data">
              <router-link :to="{ name: 'EXSBInvoiceShow', params: { id: '/core/public/index.php/api/e_x_s_b_invoices/' + data.item.idEXSBInvoice }}">
                {{ data.item.invoiceNumber }}
              </router-link>
            </template>
            <template v-slot:cell(addedRefund)="data">
              <template v-if="data.item.refundIds.length === 0">
                <b-button v-if="checkRoles('finances', 'EXSBRefundCreate')" variant="info" size="sm" @click="showCreateRefundModal(data.item.id)" class="ml-2">
                  <i class="fal fa-plus mr-1"></i> {{ $t('buttons.addRefund') }}
                </b-button>
              </template>
              <template v-else-if="data.item.refundIds.length > 0">
                <span v-for="(refund, refundId) in data.item.refundIds" :key="refundId">
                  <router-link :to="{ name: 'EXSBRefundUpdate', params: { id: '/core/public/index.php/api/e_x_s_b_refunds/' + refund.id }}">
                    {{ refund.value }}
                  </router-link>
                </span>
              </template>
            </template>
          </b-table>
          <div class="alert alert-danger m-4" role="alert">
            <p class="danger">{{$t('views.reports.index.diffPaymentInfo')}}</p>
          </div>
          <div class="form-group pb-2 col-sm-12">
            <div class="float-right">
              <b-button v-if="downloadXlsStatus === 0" variant="info" @click="downloadXLS()" v-b-tooltip.hover :title="$t('buttons.downloadXLS')" class="float-left ml-2 mr-2 btn-circle">
                <i class="fal fa-file-spreadsheet"></i>
              </b-button>
              <b-button v-if="downloadXlsStatus === 1" variant="success" v-b-tooltip.hover :title="$t('buttons.downloadXLS')" class="float-left ml-2 mr-2 btn-circle">
                <i class="fal fa-spinner fa-spin"></i>
              </b-button>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </div>
    <CreateRefundModal :id-bank-payment="idBankPayment" @reload="fetchData()" />
  </div>
</template>

<script>
import { checkPagePermission, checkPermission } from '@/utils/checkRoles'
import ApiService from '@/utils/ApiService'
import CreateRefundModal from '@/components/Dashboard/Views/BusinessBundle/exsbrefund/modals/CreateRefundModal.vue'
import { mapMutations } from 'vuex'
import Loader from '@/components/Dashboard/Layout/Loader.vue'
export default {
  name: 'notFullBankPayments',
  components: { Loader, CreateRefundModal },
  data () {
    return {
      loading: true,
      rowsData: [],
      downloadXlsStatus: 0,
      columns: [
        { key: 'paymentDate', label: this.$t('views.exsbpaymentsmade.form.paymentDate') },
        { key: 'payer', label: this.$t('tableHeadings.payer') },
        { key: 'description', label: this.$t('global.description') },
        { key: 'idEXSBInvoice', label: this.$t('views.exsbpaymentsmade.list.invoice') },
        { key: 'paymentsMade', label: this.$t('tableHeadings.valueSingle') },
        { key: 'value', label: this.$t('views.exsbbankpackages.show.value') },
        { key: 'paymentsMadeQuantity', label: this.$t('tableHeadings.paymentsMadeQuantity') },
        { key: 'diffPayment', label: this.$t('tableHeadings.diffPayment') },
        { key: 'addedRefund', label: this.$t('tableHeadings.addedRefund') }
      ],
      idBankPayment: null
    }
  },
  beforeCreate () {
    checkPagePermission('configuration', 'FinancialReportList')
  },
  created () {
    this.fetchData()
  },
  methods: {
    showCreateRefundModal (idBankPayment) {
      this.idBankPayment = '/core/public/index.php/api/e_x_s_b_bank_payments/' + idBankPayment
      this.toggleCreateRefundModal()
    },
    async downloadXLS () {
      this.downloadXlsStatus = 1
      let params = {
        xls: 1
      }
      await new ApiService('reports/notfullbankpayments', params).downloadFile('not_full_bankpayments_.xls')
      this.downloadXlsStatus = 0
    },
    async fetchData () {
      this.loading = true
      this.rowsData = await new ApiService('reports/notfullbankpayments').getResults()
      this.loading = false
    },
    checkRoles (type, view = null, component = null) {
      return checkPermission(type, view, component)
    },
    ...mapMutations({
      toggleCreateRefundModal: 'exsbrefund/createModal/toggleModal'
    })
  }
}
</script>
